<template>
  <notepad-views
    :noteId="noteId"
    :reference="reference"
    :customFilterFunction="customFilterFunction"
    :customDataFunction="customDataFunction"
    :customCreationForm="customCreationForm"
    :customFilterForm="customFilterForm"
    :showActions="showActions"
    :add-note-disabled="addNoteDisabled"
    @note-edit-loaded="$emit('note-edit-loaded', $event)"
    @note-detail-loaded="$emit('note-detail-loaded', $event)"
    @note-list-loaded="$emit('note-list-loaded', $event)"
  >
    <!-- @slot This slot is used to insert components
    into the notepad header -->
    <template #notepad-header>
      <slot
        name="notepad-header"
      />
    </template>
    <!-- @slot This slot is used to insert components
    into the note breadcrumb -->
    <template #note-breadcrumb="props">
      <slot
        name="note-breadcrumb"
        v-bind="props"
      >
      </slot>
    </template>
    <!-- @slot This slot is used to insert components
    into the note card title -->
    <template #note-title="props">
      <slot
        name="note-title"
        v-bind="props"
      />
    </template>
    <!-- @slot This slot is used to insert components
    into the note card subtitle -->
    <template #note-subtitle="props">
      <slot
        name="note-subtitle"
        v-bind="props"
      />
    </template>
    <!-- @slot This slot is used to insert el-form-item
    components into the Filter popover form -->
    <template #filter-form="props">
      <slot
        name="filter-form"
        v-bind="props"
      />
    </template>
    <!-- @slot This slot is used to insert el-form-item
    components into the Note creation form -->
    <template #creation-form="props">
      <slot
        name="creation-form"
        v-bind="props"
      />
    </template>
  </notepad-views>
</template>

<script>
import NotepadViews from '#/notes/components/NotepadViews'
import { mapMutations } from 'vuex'
import {ENVIRONMENTS} from '#/notes/components/definitions'
import notesMutations from '#/notes/store/mutationTypes'

export default {
  name: 'Notepad',
  components: {
    NotepadViews
  },
  props: {
    /**
     * The id for the note to be viewed
     * This props triggers the Details view on the Notepad
     */
    noteId: {
      type: String
    },
    /**
     * The reference object is used to detect the current context and attach notes to an entity
     * {String} id : uuid to identify entity
     * {String} label : entity label, used for display and navigation
     * {String} domain : refers to the product "module", ex.: Claims, Policies, etc
     * {String} level: deprecated this will be removed in the future
     */
    reference: {
      type: Object,
      default: () => ({})
    },
    /**
     * Consumer-defined filters, set in notepad wrapper by a BriteCore product.
     * This filter take precedence against custom form filters.
     */
    consumerFilters: {
      type: Object,
      default: () => ({})
    },
    /**
     * Data of filter form, same as 'el-form' model prop
     */
    customFilterForm: {
      type: Object,
      default: () => ({})
    },
    /**
     * Data of creation form, same as 'el-form' model prop
     */
    customCreationForm: {
      type: Object,
      default: () => ({})
    },
    /**
     * Function that returns a predicate that is used to filter the notes list
     * @param {Object} customFilters the current custom filters that are being applied
     * @returns {Function} a predicate function to filter the list. The predicate is invoked with one argument: (note).
     */
    customFilterFunction: {
      type: Function,
      default: ({userFilters}) => userFilters
    },
    /**
     * Function that returns the custom_data field to be stored
     * @param {Object} noteForm the note creation form object
     * @returns {Function} a function that returns the custom_data field to be stored
     */
    customDataFunction: {
      type: Function,
      default: () => ({})
    },

    /**
     * The environment to configure the Notepad
     * ex.: ENVIRONMENTS.GEN_2, ENVIRONMENTS.GEN_3
     */
    env: {
      type: String,
      default: ENVIRONMENTS.DEFAULT,
      validator: (v) => Object.values(ENVIRONMENTS).includes(v)
    },

    /**
     * Prop to allow each note card to show actions.
     */
    showActions: {
      type: Boolean,
      default: true
    },

    /**
     * Prop to disable Add Note button.
     */
    addNoteDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations({
      setConsumerFilters: notesMutations.SET_CONSUMER_FILTERS,
      setEnvironment: notesMutations.SET_ENVIRONMENT
    })
  },
  watch: {
    env: {
      handler (env) {
        this.setEnvironment(env)
      },
      immediate: true
    },
    consumerFilters: {
      handler (consumerFilters) {
        this.setConsumerFilters(consumerFilters)
      },
      immediate: true
    }
  }
}
</script>
